import { render, staticRenderFns } from "./ErroredMainframeItemsComponent.vue?vue&type=template&id=4d21ec7c&scoped=true&"
import script from "./ErroredMainframeItemsComponent.vue?vue&type=script&lang=js&"
export * from "./ErroredMainframeItemsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d21ec7c",
  null
  
)

export default component.exports